import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import AdjustmentReport from './AdjustmentReport';
import BlackoutReport from './BlackoutReport';
import PromotionReport from './PromotionReport';
import ReservationReport from './ReservationReport';
import EuropcarReservationReport from './EuropcarReservationReport';
import BreakupReport from './BreakupReport';
import RoutesWebsiteLog from './RoutesWebsiteLog';
import SkyScannerReservationReport from './SkyScannerReservationReport';
import ClickUtilizationReport from './ClickUtilizationReport';
import AutomationSchedulerJobs from './AutomationSchedulerJobs';
import GovernmentReservations from './GovernmentReservations';
import DetailedClickUtilizationReport from './DetailedClickUtilizationReport';
import { EmptyState, FormSection, PageHeader } from '../../ui';


import Select from "../../ui/PortalSelect";

export default function Reports() {

  const [lgShow, setLgShow] = useState(false);
  const [reportName, setReportName] = useState("");
  const [deUser, setDeUser] = useState("0");
  const loggedInUser = sessionStorage.getItem("user_token");
  const foundUser = JSON.parse(loggedInUser);
  
  const userEmail = foundUser['userEmail']
  const userArray = ['sai@caledontechnologies.com','pravin@routes.ca','sharadhi@caledontechnologies.com', 'namratha@routes.ca', 'vky@routes.ca', 'madhu@routes.ca', 'anoop@routes.ca', 'varun@routes.ca', 'sam@routes.ca', 'bella@routes.ca','bassi@routes.ca','deepak@caledontechnologies.com','pooja@caledontechnologies.com','vikkas@caledontechnologies.com']
  const SchedulerAccessArray = ['sai@caledontechnologies.com', 'sharadhi@caledontechnologies.com', 'vky@routes.ca', 'madhu@routes.ca', 'sam@routes.ca','bassi@routes.ca','cyanez@grupoastral.com.mx','aesparza@grupoastral.com.mx','jose.galeana@grupoastral.com.mx','tampa@routes.ca','mia@routes.ca','fll@routes.ca' ]
  const SchedulerAccessReport = [408214,245223,796446]
  useEffect(() => {
    if (foundUser.account_type._id == '767610') {
      setDeUser("1")
    }
    // if (SchedulerAccessReport.includes(foundUser.account_type._id)) {
    //   setDeUser("2")
    // }
  },[])
  //Option for Report name
  let reportNameOptions = [];
  if (deUser === "1") {
    reportNameOptions = [
      { value: "Reservation", label: "Reservation" },
      { value: "Adjustment", label: "Adjustment" },
      { value: "Blackout", label: "Blackout" },
    //   { value: "Automation Scheduler Jobs", label: "Automation Scheduler Jobs" }
    ];
  }
//    else if (deUser === "2") {
//     reportNameOptions = [
//       { value: "Automation Scheduler Jobs", label: "Automation Scheduler Jobs" }
//     ];
//   } 
  else {
    reportNameOptions = [
      { value: "Adjustment", label: "Adjustment" },
      { value: "Blackout", label: "Blackout" },
      { value: "Promotion", label: "Promotion" },
      { value: "Reservation", label: "Reservation" },
      { value: "Europcar Reservation", label: "Europcar Reservation" },
      { value: "Routes Website Log", label: "Routes Website Log" },
      { value: "SkyScanner Reservation Report", label: "SkyScanner Reservation Report" },
      { value: "Click Utilization Report", label: "Click Utilization Report" },
      { value: "Detailed Click Utilization Report", label: "Detailed Click Utilization Report" },
      { value: "Automation Scheduler Jobs", label: "Automation Scheduler Jobs" },
      { value: "Government Reservations", label: "Government Reservations" }
    ];
  }

  // const reportNameOptions = deUser === "1"
  //   ? [{ value: "Reservation", label: "Reservation" },
  //     { value: "Adjustment ", label: "Adjustment" },
  //     { value: "Blackout ", label: "Blackout" }
  //   ]
  //   : [
  //       { value: "Adjustment", label: "Adjustment" },
  //       { value: "Blackout", label: "Blackout" },
  //       { value: "Promotion", label: "Promotion" },
  //       { value: "Reservation", label: "Reservation" },
  //       { value: "Europcar Reservation", label: "Europcar Reservation" },
  //       { value: "Routes Website Log", label: "Routes Website Log" },
  //       { value: "SkyScanner Reservation Report", label: "SkyScanner Reservation Report" },
  //       { value: "Click Utilization Report", label: "Click Utilization Report" },
  //       { value: "Automation Scheduler Jobs", label: "Automation Scheduler Jobs" }
  //     ];
  // const filteredReportNameOptions = userArray.includes(userEmail)
  //   ? reportNameOptions
  //   : reportNameOptions.filter(option => option.value !== "Click Utilization Report");
    const filteredReportNameOptions = reportNameOptions.filter(option => {
      if (option.value === "Click Utilization Report" && !userArray.includes(userEmail)) {
        return false; // hide it
      }
    //   if (option.value === "Automation Scheduler Jobs" && !SchedulerAccessArray.includes(userEmail)) {
    //     return false; // hide it
    //   }
      return true; // keep all other options
    });
  const handleInputChangeReportName = characterEntered => {
    setReportName(characterEntered.value);
  };


  return (
    <>
      <PageHeader
        title="Reports"
        subtitle="Choose an operational report, then use its filters to review and export the data you need."
        eyebrow="Analytics"
        help={(
          <button type="button" className="btn btn-outline-primary" onClick={() => setLgShow(true)}>
            Help
          </button>
        )}
      />

      <Modal
            size="lg"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="reports-help-title"
          >
            <Modal.Header closeButton>
              <Modal.Title id="reports-help-title" >
                Instructions to view Reports
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ol>
                <li>Select the report you want to view
                </li>
                <li>Select Report name from the dropdown
                </li>
                <li>Select Account Name, Location Name, From and To date from Calender</li>
                <li>Select Rate Code, OTA , Car Class from the checkbox
                </li>
                <li>Click On Fetch Button
                </li>
              </ol>

              <h5>Existing Reports:
              </h5>
              <ol>
                <li>To view/edit user ID’s, select company name from drop down {'>'} view/edit the user details {'>'} submit.</li>
                <li><strong>Note:</strong> Company name and user ID fields are non-editable</li>
              </ol>

              <h5>To deactivate the User</h5>
              <ul>
                <li>To view/Download the existing Reports select the Account Name and Location Name from dropdown, From and To date from calender, and then select the Rate Code, OTA , Car Class from the checkbox .
                </li>

              </ul>
            </Modal.Body>
      </Modal>
      <FormSection
        title="Report selection"
        description="Select a report to reveal its available filters, results, and export options."
      >
        <div className="row g-3 align-items-end">
          <div className="col-12 col-md-6 col-lg-4">
            <label htmlFor="report_name" className="form-label">
              Select Report*
            </label>
            <Select
              value={{ value: reportName, label: (reportName ? reportName : "Select Report") }}
              inputId="report_name"
              name="report_name"
              options={filteredReportNameOptions}
              onChange={handleInputChangeReportName}
            />
          </div>
        </div>
      </FormSection>


      {!reportName && (
        <EmptyState
          compact
          title="Select a report to get started"
          description="Choose a report from the list above to display its filters, results, and export options."
        />
      )}


      {reportName === 'Adjustment' ? <AdjustmentReport /> :
        reportName === 'Blackout' ? <BlackoutReport /> :
          reportName === 'Promotion' ? <PromotionReport /> :
            reportName === 'Reservation' ? <ReservationReport /> : 
            reportName === 'BreakupReport' ? <BreakupReport /> : 
            reportName === 'Europcar Reservation' ? <EuropcarReservationReport /> : 
            reportName === 'Routes Website Log' ? <RoutesWebsiteLog /> :
            reportName === 'SkyScanner Reservation Report' ? <SkyScannerReservationReport /> :
            reportName === 'Click Utilization Report' ? <ClickUtilizationReport /> :
            reportName === 'Detailed Click Utilization Report' ? <DetailedClickUtilizationReport /> :
            reportName === 'Automation Scheduler Jobs' ? <AutomationSchedulerJobs /> : 
            reportName === 'Government Reservations' ? <GovernmentReservations /> : ""}
    </>
  );
}
